export enum CrmFieldTypeEnum {
  USER_FIRSTNAME = 'USER_FIRSTNAME',
  USER_LASTNAME = 'USER_LASTNAME',
  USER_BIRTHDAY = 'USER_BIRTHDAY',
  USER_ZIPCODE = 'USER_ZIPCODE',
  SHORT_TEXT = 'SHORT_TEXT',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  SELECT = 'SELECT',
  BOOL = 'BOOL',
  RATING = 'RATING',
}

export enum CrmConnectorTypeEnum {
  ZENCHEF = 'ZENCHEF',
}

export enum CrmFieldStatusEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum CrmTabEnum {
  FORM = 'FORM',
  SETTINGS = 'SETTINGS',
}

export interface CrmFieldMappingDTO {
  externalField: string;
  fieldId: string;
}

export interface CrmConnectorSettingsDTO {
  connectorType: CrmConnectorTypeEnum;
  restaurantId: string;
}

export interface CrmExternalStoreDTO {
  externalStoreId: string;
  name: string;
}

export interface CrmStoreMappingDTO {
  externalStoreId: string;
  storeId: string;
}

export interface CrmConnectorAccountDTO {
  id: string;
  franchiseId: string;
  type: CrmConnectorTypeEnum;
  settings: CrmConnectorSettingsDTO;
  fieldMapping: CrmFieldMappingDTO[];
  availableFields: string[];
  availableStores?: CrmExternalStoreDTO[];
  storeMapping?: CrmStoreMappingDTO[];
  dateCreated: string;
  lastModified: string;
  lastSyncAt: string | null;
  disabledAt: string | null;
}

export enum CrmConnectorTestStatusEnum {
  OK = 'OK',
  MALFORMED_CREDENTIALS = 'MALFORMED_CREDENTIALS',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  RATE_LIMITED = 'RATE_LIMITED',
  TOOL_ERROR = 'TOOL_ERROR',
  UNREACHABLE = 'UNREACHABLE',
  UNREADABLE_RESPONSE = 'UNREADABLE_RESPONSE',
  UNSUPPORTED_CONNECTOR = 'UNSUPPORTED_CONNECTOR',
}

export interface TestCrmConnectorDTO {
  type: CrmConnectorTypeEnum;
  credentials: {
    restaurantId: string;
    apiKey: string;
  };
}

export interface CrmConnectorTestResultDTO {
  status: CrmConnectorTestStatusEnum;
  detail: string;
  guestsFound: number;
  availableFields: string[];
  availableStores?: CrmExternalStoreDTO[];
}

/** The API key is write-only: it is sent here and never read back. */
export interface ConnectCrmConnectorDTO {
  credentials: {
    connectorType: CrmConnectorTypeEnum;
    restaurantId: string;
    apiKey: string;
  };
  fieldMapping: CrmFieldMappingDTO[];
  availableFields: string[];
  availableStores: CrmExternalStoreDTO[];
}

export interface ValidationDTO {
  type: CrmFieldTypeEnum;
  isRequired: boolean;
  isMultiSelect?: boolean;
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
  minDate?: string;
  maxDate?: string;
  minSelection?: number;
  maxSelection?: number;
  options?: string[];
}

export interface CrmSelectFieldOption {
  type: CrmFieldTypeEnum;
  label: string;
}

export interface CrmFieldDTO {
  id: string;
  localId: string;
  label: string;
  /** The validation of the field */
  validation: ValidationDTO;
  /** The status of the field */
  status: CrmFieldStatusEnum;
  /** A user field link data from the user instead of loyalty card */
  isUserField?: boolean;
  /** A locked fields cannot be modified or deleted */
  isLocked: boolean;
  /** The values of the field */
  values?: string[];
  /** The connector feeding the column, null when a merchant fills it by hand. */
  connectorType?: CrmConnectorTypeEnum | null;
  /** False for a column kept out of the customer form and off the CRM page; absent means asked. */
  isAskedToCustomer?: boolean;
}

/** A rating travels as a number and a Yes/No as a boolean, not as text. */
export type CrmFieldValue = string | number | boolean | string[] | null;

export interface ClientCrmField extends Omit<CrmFieldDTO, 'id'> {
  id?: string;
  value: CrmFieldValue;
  error?: string | null;
  isValid?: boolean;
}

export interface UpdateClientCrmFieldDTO {
  fieldId: string;
  value: CrmFieldValue;
}

export interface CrmSettingsDTO {
  points: number | null;
  isRequired: boolean;
}

export interface CrmInDTO {
  settings: CrmSettingsDTO;
  fields?: CrmFieldDTO[];
}
export interface CrmOutDTO {
  settings: CrmSettingsDTO;
  fields?: ClientCrmField[];
}
